const encodeHTMLEntities = (str: string) => {
  return str.replace(/[\u00A0-\u9999<>&]/g, function (i) {
    return '&#' + i.charCodeAt(0) + ';'
  })
}

export { encodeHTMLEntities }
